import React, { FC } from 'react';

import { RequiredRule } from 'devextreme-react/cjs/form';

import { AppFieldBox } from 'components/appComponents';
import { TextBox, Validator } from 'devextreme-react';

type PhoneProps = {
  label: string;
  value: string;
  readOnly: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
};

const Phone: FC<PhoneProps> = ({ value, readOnly, onChange, disabled, label }) => {
  return (
    <AppFieldBox label={label} labelTop>
      <TextBox
        stylingMode="underlined"
        readOnly={readOnly}
        disabled={disabled}
        placeholder="Введите телефон"
        mode="text"
        value={value}
        onValueChange={onChange}
        mask="+7 (000) 000-00-00"
      >
        <Validator>
          <RequiredRule message="Заполните поле Телефон" />
        </Validator>
      </TextBox>
    </AppFieldBox>
  );
};

export default Phone;
